import { GlButton } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { isEmpty } from 'lodash-es';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { scrollToElement } from '~/lib/utils/scroll_utils';
import { slugify } from '~/lib/utils/text_utility';
import { getLocationHash, setUrlParams } from '~/lib/utils/url_utility';
import { BACK_URL_PARAM, CREATED_ASC } from '~/releases/constants';
import { renderGFM } from '../../behaviors/markdown/render_gfm.js?vue3';
import CrudComponent from '../../vue_shared/components/crud_component.vue?vue3';
import { __, sprintf } from '~/locale';
import EvidenceBlock from './evidence_block.vue?vue3';
import ReleaseBlockAssets from './release_block_assets.vue?vue3';
import ReleaseBlockDetails from './release_block_details.vue?vue3';
import ReleaseBlockTitle from './release_block_title.vue?vue3';
import ReleaseBlockMilestoneInfo from './release_block_milestone_info.vue?vue3';
import ReleaseBlockDeployments from './release_block_deployments.vue?vue3';
export default {
    name: 'ReleaseBlock',
    components: {
        GlButton,
        CrudComponent,
        EvidenceBlock,
        ReleaseBlockAssets,
        ReleaseBlockTitle,
        ReleaseBlockMilestoneInfo,
        ReleaseBlockDeployments,
        ReleaseBlockDetails
    },
    directives: {
        SafeHtml
    },
    props: {
        release: {
            type: Object,
            required: true
        },
        sort: {
            type: String,
            required: false,
            default: CREATED_ASC
        },
        deployments: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        previousReleaseSha: {
            type: String,
            required: false,
            default: ''
        },
        comparePath: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            isHighlighted: false
        };
    },
    computed: {
        htmlId () {
            if (!this.release.tagName) {
                return null;
            }
            return slugify(this.release.tagName);
        },
        assets () {
            return this.release.assets || {};
        },
        hasEvidence () {
            return Boolean(this.release.evidences && this.release.evidences.length);
        },
        milestones () {
            return this.release.milestones || [];
        },
        links () {
            return this.release._links || {};
        },
        shouldRenderAssets () {
            return Boolean(this.assets.links.length || this.assets.sources && this.assets.sources.length);
        },
        shouldRenderMilestoneInfo () {
            return Boolean(!isEmpty(this.release.milestones));
        },
        editLink () {
            if (this.links.editUrl) {
                const queryParams = {
                    [BACK_URL_PARAM]: window.location.href
                };
                return setUrlParams(queryParams, {
                    url: this.links.editUrl
                });
            }
            return undefined;
        },
        shouldApplyDeploymentsBlockCss () {
            return Boolean(this.shouldRenderAssets || this.hasEvidence || this.release.descriptionHtml);
        },
        shouldApplyAssetsBlockCss () {
            return Boolean(this.hasEvidence || this.release.descriptionHtml);
        },
        isFutureRelease () {
            return new Date() < new Date(this.release.releasedAt);
        }
    },
    mounted () {
        this.renderGFM();
        const hash = getLocationHash();
        if (hash && slugify(hash) === this.htmlId) {
            this.isHighlighted = true;
            setTimeout(()=>{
                this.isHighlighted = false;
            }, 2000);
            scrollToElement(this.$el);
        }
    },
    methods: {
        renderGFM () {
            renderGFM(this.$refs['gfm-content']);
        }
    },
    safeHtmlConfig: {
        ADD_TAGS: [
            'gl-emoji'
        ]
    },
    i18n: {
        editButton: __('Edit release'),
        editButtonAriaLabel: (title)=>sprintf(__('Edit release (%{title})'), {
                title
            })
    },
    commonCssClasses: 'gl-border-b-1 gl-pb-5 gl-border-b-solid gl-border-default'
};
